import { ENTITY_ITEMS_DROPDOWN_LIMIT } from '@/_legacy/constants';
import { Ref } from 'vue';
import { autocompleteField, inputField } from '@/ui/components/form';
import { Task, useValidation } from '@/ui/concerns';
import { Gateway, validate } from '@/entities/gateway';
import { apiErrorMessage } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { SelectOptions } from '@/ui/types';

export function useGatewayForm(record: Ref<Gateway>, task: Task) {
  const {
    validationErrors,
    hasNoValidationErrors,
    showValidationErrors,
  } = useValidation(validate, record, task.state);

  const handleSubmit = () => {
    showValidationErrors.value = true;
    if (hasNoValidationErrors.value) {
      task.run();
    }
  };

  const formFields = (entityItems: SelectOptions) => [
    inputField(
      {
        name: 'title',
        label: t('gateways.title'),
        placeholder: t('gateways.enter-title'),
        value: record.value.title,
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },

      value => {
        record.value.title = value;
      },
    ),

    autocompleteField({
      name: 'entityItem',
      label: t('common.entity-item'),
      value: record.value.entityItem,
      placeholder: t('gateways.enter-entity-item'),
      required: true,
      data: entityItems,
      errors: validationErrors.value,
      disabled: task.state.value.pending,
      limit: ENTITY_ITEMS_DROPDOWN_LIMIT,
    },
    value => {
      record.value.entityItem = value;
    }),

    apiErrorMessage(task.state.value),
  ];

  return {
    formFields,
    handleSubmit,
  };
}
